<!--==================================
=            COLOR GROUPS            =
===================================-->

<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Color Pickers</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Model</div>
          <div slot="card-body">
            <div>
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-btn v-for="t in types" :key="t" class="my-4" block @click="type = t">{{ t }}</v-btn>
                  </v-col>
                  <v-col class="d-flex justify-center">
                    <v-color-picker v-model="color"></v-color-picker>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-sheet dark class="pa-4">
                      <pre>{{ showColor }}</pre>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Swatches</div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-color-picker class="ma-2" show-swatches></v-color-picker>
                <v-color-picker class="ma-2" :swatches="swatches" show-swatches></v-color-picker>
                <v-color-picker class="ma-2" show-swatches swatches-max-height="300px"></v-color-picker>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Inputs</div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-color-picker class="ma-2" hide-inputs></v-color-picker>
                <v-color-picker class="ma-2" hide-mode-switch></v-color-picker>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Canvas</div>
          <div slot="card-body">
            <v-row justify="space-around">
              <v-color-picker class="ma-2" hide-canvas></v-color-picker>
              <v-color-picker class="ma-2" canvas-height="300"></v-color-picker>
              <v-color-picker class="ma-2" dot-size="30"></v-color-picker>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <div>
              <v-container>
                <v-row justify="space-around">
                  <v-switch v-model="showSwatches" class="mx-2" label="Show Swatches"></v-switch>
                  <v-switch v-model="hideInputs" class="mx-2" label="Hide Inputs"></v-switch>
                  <v-switch v-model="hideCanvas" class="mx-2" label="Hide Canvas"></v-switch>
                  <v-switch v-model="hideModeSwitch" class="mx-2" label="Hide Mode Switch"></v-switch>

                  <v-col class="mx-2" cols="3">
                    <v-select v-model="mode" :items="modes" label="Mode"></v-select>
                  </v-col>
                </v-row>
              </v-container>

              <v-color-picker
                v-model="color"
                :hide-canvas="hideCanvas"
                :hide-inputs="hideInputs"
                :hide-mode-switch="hideModeSwitch"
                :mode.sync="mode"
                :show-swatches="showSwatches"
                class="mx-auto"
              ></v-color-picker>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    swatches: [
      ["#FF0000", "#AA0000", "#550000"],
      ["#FFFF00", "#AAAA00", "#555500"],
      ["#00FF00", "#00AA00", "#005500"],
      ["#00FFFF", "#00AAAA", "#005555"],
      ["#0000FF", "#0000AA", "#000055"]
    ],
    types: ["hex", "hexa", "rgba", "hsla", "hsva"],
    type: "hex",
    hex: "#FF00FF",
    hexa: "#FF00FFFF",
    rgba: {
      r: 255,
      g: 0,
      b: 255,
      a: 1
    },
    hsla: {
      h: 300,
      s: 1,
      l: 0.5,
      a: 1
    },
    hsva: {
      h: 300,
      s: 1,
      v: 1,
      a: 1
    },
    color: "#8E00FF",
    hideCanvas: false,
    hideInputs: false,
    hideModeSwitch: false,
    mode: "rgba",
    modes: ["rgba", "hsla", "hexa"],
    showSwatches: false
  }),
  computed: {
    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      }
    },
    showColor() {
      if (typeof this.color === "string") return this.color;

      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    }
  }
};
</script>


<!--====  End of COLOR GROUPS  ====-->
